export const FIO_ERROR_CYRILLIC = 'ФИО может состоять только из кириллицы';
export const FIO_ERROR_FIRST_CYRILLIC_CHARACTER = 'ФИО может начинаться только с кириллицы';
export const FIO_ERROR_WHITESPACE_AND_HYPHEN =
    'Между словами разрешены одиночные пробелы или одиночные дефисы';
export const FIO_ERROR_SPACES = 'Укажите фамилию, имя и отчество через пробел';

export const validateFioValue = (value: string) => {
    if (!/^[\sЁА-яё-]*$/.test(value)) {
        return FIO_ERROR_CYRILLIC;
    }

    if (!/^\s*[ЁА-яё]/.test(value)) {
        return FIO_ERROR_FIRST_CYRILLIC_CHARACTER;
    }

    if (!/^\s*[ЁА-яё]+([ -][ЁА-яё]+)*\s?$/.test(value)) {
        return FIO_ERROR_WHITESPACE_AND_HYPHEN;
    }

    return undefined;
};

export const validateFioOneFieldValue = (value: string) => {
    const invalid = validateFioValue(value);
    if (invalid) return invalid;

    const parts = value.trim().split(' ');
    if (parts.length < 2) return FIO_ERROR_SPACES;

    return undefined;
};
